export default __webpack_public_path__ + "static/media/ic_tlp_24.43116971.svg";